import { createSlice } from '@reduxjs/toolkit';

import { HighRiskSupplement } from '@models/highRiskSupplement';

import { handleSearchHighRiskSupplements } from './actions';
import { IHighRiskSupplementsSearchState } from './slice.interface';

const initialState: IHighRiskSupplementsSearchState = {
  data: null,
  error: false,
  isLoading: false,
  paginatedData: null,
  searchValue: '',
};

export const highRiskSupplementsSearchSlice = createSlice({
  name: 'high-risk-supplements-search',
  initialState,
  reducers: {
    saveSearchValue: (state, action) => {
      state.searchValue = action.payload;
    },
    removeHighRiskSupplementsSearch: state => {
      state.paginatedData = null;
      state.data = null;
      state.searchValue = '';
      state.isLoading = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(
        handleSearchHighRiskSupplements.pending,
        (state: IHighRiskSupplementsSearchState, action) => {
          state.isLoading = true;
          state.error = false;
        },
      )
      .addCase(
        handleSearchHighRiskSupplements.rejected,
        (state: IHighRiskSupplementsSearchState, action) => {
          state.isLoading = false;
          state.error = true;
        },
      )
      .addCase(
        handleSearchHighRiskSupplements.fulfilled,
        (state: IHighRiskSupplementsSearchState, action) => {
          state.isLoading = false;
          const { page, pageCount } = action.payload.data.pagination;
          const normalizedData = Array.isArray(action?.payload?.data?.tableData)
            ? action.payload.data.tableData.map(item => new HighRiskSupplement(item))
            : [];
          if (pageCount === 1 || page === 1) {
            state.data = {
              ...action.payload.data,
              tableData: normalizedData,
            };
          } else {
            state.data = {
              ...action.payload.data,
              tableData: [...(state.data?.tableData ?? []), ...normalizedData],
            };
          }
          state.paginatedData = {
            ...action.payload.data,
            tableData: normalizedData,
          };
        },
      );
  },
});

export const { removeHighRiskSupplementsSearch, saveSearchValue } =
  highRiskSupplementsSearchSlice.actions;

export default highRiskSupplementsSearchSlice.reducer;
